import React from 'react';
import { parseISO } from 'date-fns';
import { useFragment, graphql } from 'react-relay';
import { RelativeDate } from '@atlassian/jira-development-common';
import { useLocaleTimeZone } from '@atlassian/jira-development-common/src/common/utils/hooks/use-locale-timezone';
import type { lastUpdatedCell_softwareCodePage$key } from '@atlassian/jira-relay/src/__generated__/lastUpdatedCell_softwareCodePage.graphql';

type lastUpdatedCellProps = {
	lastUpdatedCellData: lastUpdatedCell_softwareCodePage$key;
};

const LastUpdatedCell = ({ lastUpdatedCellData }: lastUpdatedCellProps) => {
	const { locale, timeZone } = useLocaleTimeZone();
	const data = useFragment(
		graphql`
			fragment lastUpdatedCell_softwareCodePage on DevOpsPullRequestDetails {
				lastUpdated @required(action: THROW)
			}
		`,
		lastUpdatedCellData,
	);

	return <RelativeDate date={parseISO(data.lastUpdated)} locale={locale} timeZone={timeZone} />;
};

export default LastUpdatedCell;
